// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__7L8KV","modalContent":"modal_modalContent__N2vbN","spinner":"modal_spinner__+S0dZ","modalHeader":"modal_modalHeader__r1GRT","close":"modal_close__gIWER"};